export enum WorkflowStepsTarget {
  BEFORE_DUE_DATE = 'before_due_date_steps',
  AFTER_DUE_DATE = 'after_due_date_steps',
}
